export default __webpack_public_path__ + "static/media/product6.ddda0770.jpg";